export const scrollToElement = () => {
  const $buttonToScroll = document.querySelector<HTMLElement>('[data-scroll-button]')
  const $elementScrollTo = document.querySelector<HTMLElement>('[data-scroll-to]')

  if ($buttonToScroll) {
    $buttonToScroll.addEventListener('click', () => {
      $elementScrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  }
}
